import React from 'react';
import { formatEffectiveDate } from '../helpers';

const ReturnPolicy = () => {
  return (
    <div className="container-fluid mt-5 mb-5">
      <div className="row">
        <div className="col-12 col-lg-10 offset-lg-1">
          <h1 className="display-4 fw-800 text-dark opacity-85 mb-4">Return & Cancellation Policy</h1>
          <div className="card shadow-sm p-4 bg-white">
            <p className="text-muted mb-4">Effective Date: {formatEffectiveDate()}</p>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">1. Service Cancellation</h5>
              <p className="text-dark opacity-75">
                Clients may request cancellation of ongoing services by providing written notice in accordance with the terms outlined in their specific service agreement. Cancellation terms, including applicable notice periods and fees (if any), will be governed by the signed agreement.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">2. Refund Eligibility</h5>
              <p className="text-dark opacity-75">
                Refund requests are evaluated on a case-by-case basis, considering the nature of services rendered, progress of work, and contractual obligations. Partial or full refunds may be issued only if deemed appropriate and in alignment with the terms of engagement.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">3. Project Adjustments</h5>
              <p className="text-dark opacity-75">
                Clients may request modifications within the originally agreed scope of work. Any change that constitutes a significant deviation or expansion of scope may require a revised agreement and may be subject to additional charges or adjusted timelines.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">4. Quality Assurance</h5>
              <p className="text-dark opacity-75">
                JumpFast Technologies is committed to delivering high-quality solutions. If a client is unsatisfied with the quality of service, we encourage open communication and will make commercially reasonable efforts to resolve issues through revisions or enhancements.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">5. Contact Information</h5>
              <p className="text-dark opacity-75">
                For any questions, concerns, or clarification regarding our Return and Cancellation Policy, please contact us at <a href="mailto:contact@jumpfast.tech" className="text-primary">contact@jumpfast.tech</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;
